module.exports = __webpack_public_path__ + "static/media/speed.5298b72d.png";